import { useEffect } from "react"
import posthog from "posthog-js"
import { GetCurrentUserResult } from "app/users/queries/getCurrentUser"
import getFullname from "utils/users/getFullName"

const useIdentifyUser = (currentUser: GetCurrentUserResult) => {
  useEffect(() => {
    if (!currentUser) return
    if (posthog.get_distinct_id() === currentUser.id.toString()) return

    if (currentUser.role === "ADMIN") {
      posthog.identify(currentUser.id.toString(), {
        role: currentUser.role,
      })
    }

    if (
      !Array.isArray(currentUser.organizationUsers) ||
      currentUser.organizationUsers.length === 0
    )
      return

    const { id, role, organizationUsers } = currentUser
    const organizationUser = organizationUsers[0]
    const { organization } = organizationUser

    if (id && organization) {
      posthog.group(
        "organization",
        organizationUser.organizationId.toString(),
        {
          organizationName: organization.displayTitle,
        }
      )
      posthog.identify(id.toString())
    }
  }, [currentUser])
}

export default useIdentifyUser
